// Display helpers for plans shaped by App\Services\Subscription\PlanCatalogService.
// 1 credit = 1 AI speaking session (any track, quick or full), charged once the first part is answered.

export function formatMoney(amount, currency = 'USD') {
    const value = Number(amount || 0);
    const code = (currency || 'USD').toUpperCase();
    const formatted = value.toFixed(2);
    return code === 'USD' ? `$${formatted}` : `${code} ${formatted}`;
}

export function periodLabel(plan) {
    const months = Number(plan.months || plan.intervalCount || 1);
    if (months === 1) return 'month';
    if (months === 12) return 'year';
    return `${months} months`;
}

export function perTestLabel(plan) {
    if (!plan.pricePerTest) return null;
    return `≈${formatMoney(plan.pricePerTest, plan.currency)} per session`;
}

export function isPaidPlan(plan) {
    return Number(plan.price) > 0;
}

// The plan to lead with: the one marked featured, else the best per-test price.
export function recommendedPlan(plans = []) {
    const paid = plans.filter(isPaidPlan);
    return paid.find(p => p.featured)
        || [...paid].sort((a, b) => (a.pricePerTest ?? Infinity) - (b.pricePerTest ?? Infinity))[0]
        || null;
}
